// Browser storage may be unavailable in an embedded preview or privacy-restricted browser.
// Keep only this non-sensitive flag in memory when persistence is not permitted.
let seenInMemory = false;
const key = '3dloc_popup_seen';

export const hasSeenNewsletter = () => {
  if (seenInMemory) return true;
  try {
    return window.sessionStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const markNewsletterSeen = () => {
  seenInMemory = true;
  try {
    window.sessionStorage.setItem(key, 'true');
  } catch {
    // Do not replace denied storage with cookies or other persistent storage.
  }
};